import moment from "moment";

/**
 * Fecha/hora que el backend de social usa para la cola de publicación.
 *
 * Importante: `Date` de react-date-picker (y otros) a veces representa medianoche **UTC**;
 * `moment(date).format("yyyy-MM-DD")` puede caer **un día antes** en zonas como Argentina (UTC-3).
 * Por eso el día del calendario se toma con getFullYear/getMonth/getDate (hora local del navegador).
 */
export function scheduleDateStringForApiFromDateAndHour(
  date: Date,
  hour: string
): string {
  if (!date || !hour) return "";
  const y = date.getFullYear();
  const mo = String(date.getMonth() + 1).padStart(2, "0");
  const d = String(date.getDate()).padStart(2, "0");
  const ymd = `${y}-${mo}-${d}`;
  const trimmed = hour.trim();
  const parsed = moment(`${ymd} ${trimmed}`, "YYYY-MM-DD HH:mm", true);
  if (parsed.isValid()) {
    /* Offset-aware local time (e.g. 2026-10-16T13:35:00-03:00).
       UTC ISO (…Z) can be stored as naive DATETIME and delay the cron by the TZ offset. */
    return parsed.format("YYYY-MM-DDTHH:mm:ssZ");
  }
  const loose = moment(`${ymd} ${trimmed}`);
  return loose.isValid() ? loose.format("YYYY-MM-DDTHH:mm:ssZ") : "";
}
